import clsx from "clsx";
import { FC, ReactNode, HtmlHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface SubMenuPanelProps extends HtmlHTMLAttributes<HTMLDivElement> {
  bgColorType?: "primary" | "secondary";
  children: ReactNode;
}

const SubMenuPanel: FC<SubMenuPanelProps> = ({ bgColorType = "primary", children, ...rest }) => {
  const bgColorTypeClasses = clsx({
    "bg-fog-00": bgColorType === "primary",
    "bg-fog-10": bgColorType === "secondary",
  });

  return (
    <div
      className={twMerge(
        "flex h-auto w-full flex-col items-stretch justify-between gap-8 p-0 lg:px-4 lg:pb-6 lg:pt-4",
        bgColorTypeClasses
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export { SubMenuPanel };
